export default __webpack_public_path__ + "static/media/765.5dc924a4.png";